export const SET_STATE = 'SET_STATE'
export const SET_TIMER = 'SET_TIMER'
export const TICK = 'TICK'
export const SINGLE_ANSWER = "SINGLE_ANSWER"
export const ANSWER = "ANSWER"
export const INPUT_ANSWER = "INPUT_ANSWER"
export const RESET_ANSWER = "RESET_ANSWER"
export const INITIALIZE_TEST = "INITIALIZE_TEST"
export const INITIALIZE_SCENARIO = "INITIALIZE_SCENARIO"
export const INITIALIZE_QUESTION = "INITIALIZE_QUESTION"
export const PASS_TEST = "PASS_TEST"
export const PASS_QUESTION = "PASS_QUESTION"
export const AWAIT_NEXT = "AWAIT_NEXT"
export const INITIALIZE_REPORT = "INITIALIZE_REPORT"
export const INITIALIZE_EXIT = "INITIALIZE_EXIT"
export const SET_FILE_TO_UPLOAD_MAP = "SET_UPLOAD_MAP"
export const SET_FILES_TO_UPLOAD = "SET_FILES_TO_UPLOAD"
export const SHOW_PASSED = "SHOW_PASSED"



// WEBPACK FOOTER //
// ./src/store/mutation-types.js